define('Components/ProductListWidget/js/views/ProductListWidgetInstanceView',['jquery','WidgetInstanceView','app',
    'ProductBlockView',
    'template!Components/ProductListWidget/templates/simple-4x1',
    'template!Components/ProductListWidget/templates/simple-4x2',
    'template!Components/ProductListWidget/templates/product-page-footer',
    'template!Components/ProductListWidget/templates/fidelity'
],
    function($, WidgetInstanceView, app,
             ProductBlockView ,
             simple4x1template,
             simple4x2template,
             productPageFooter,
             productFidelityTemplate
    ){
    return WidgetInstanceView.extend({
        name:'ProductListWidgetInstanceView',
        activeSlide: 0,
        events: {
            'click .prev':'prevSlide',
            'click .next':'nextSlide'
        },
        setup:function(){
            var view = this,
                model = view.model,
                cartProducts = app.getCart().getProducts();

            view.listenTo(model,'sync',view.onSyncDevatics);
            view.listenTo(cartProducts, 'add', view.onAddProduct);
            view.listenTo(cartProducts, 'remove', view.onAddProduct);
            model.setupDevatics('dvt_await');
            view.preRender();
            view.render();
        },
        onAddProduct: function(){
           // app.bottomNotice(t('Le produit a bien été ajouté au panier', 'Cart'));
        },
        onRemoveProduct: function(){
            //app.bottomNotice(t('Le produit a bien été retiré du  panier', 'Cart'));
        },
        onSyncDevatics:function(model){
            var view = this,
                strategyId = model.getDevaticsStrategyId(),
                recoId = model.get('recoId'),
                currencyIsoCode = app.getCurrency().getIsoCode();
            if(recoId == 'recoIgnore'){
                view.$el.hide();
                return;
            }

            view.preRender();
            view.render();
            view.$el.attr({
                'data-block':strategyId,
                'data-reco':recoId
            }).addClass('dvt-reco');
            // TODO
            view.$('.product-block').each(function(){
                var $block = $(this),
                    id_product= $block.data('id_product'),
                    product = app.getProduct(id_product);
                $block.attr('data-product',id_product);
                $block.find('a.picture,a.product-title').attr('data-product-link',id_product);
                $block.find('.btn-add').attr({
                    'data-add-to-basket':'',
                    'data-product-id':id_product,
                    'data-unit-price':product.getPrice('ttc',true,app.getCart()),
                    'data-currency':currencyIsoCode
                },id_product);
            })
        },
        afterRender:function() {
            var self = this;
            self.attachViews(ProductBlockView.initializeProductBlocksOfView(self));
        },
        getTemplate:function(){

            switch(this.model.getTemplate()){
                case "fidelity" :
                    return productFidelityTemplate;
                case "product-page-footer" :
                    return productPageFooter;
                case "checkout-CTA" :
                    return checkoutctaTemplate;
                case "simple-4x2" :
                    return simple4x2template;
                case "simple-4x1" : default :
                    return simple4x1template;
            }
        },
        slideTo:function(offset){
            var view = this,
                productContainer = view.$('.products-container'),
                slideIndex = productContainer.data('index') || 0,
                slideMax = view.model.getNbSlide()-1;
            if(offset){
                slideIndex = slideIndex+offset;
                slideIndex = slideIndex<0?slideMax:slideIndex>slideMax?0:slideIndex;
            }
            productContainer.css('left', -(100 * slideIndex) + '%').data('index',slideIndex);
        },
        nextSlide: function(){
            this.slideTo(1);
        },
        prevSlide: function(){
            this.slideTo(-1);
        }


    })
});
